/* Ninja.fi Selleasy product-page add-on interactions */
(() => {
  'use strict';

  const ROOT = '.selleasy-block-product-addon';
  const CARD = '.ppa-prod-container';
  const CHECKBOX = '.ppa-prod-checkbox-left';
  const INTERACTIVE = 'a, button, input, select, textarea, label, [role="button"], [role="link"]';

  const prepareCard = (card) => {
    if (card.dataset.ninjaSelleasyReady === 'true') return;
    const checkbox = card.querySelector(CHECKBOX);
    if (!checkbox) return;

    const title = card.querySelector('.ppa-prod-details-title')?.textContent?.trim();
    if (title && !checkbox.getAttribute('aria-label')) {
      checkbox.setAttribute('aria-label', title);
    }

    card.dataset.ninjaSelleasyReady = 'true';
  };

  const prepareRoot = (root) => {
    const cards = [...root.querySelectorAll(CARD)].filter((card) => !card.hidden);
    root.classList.toggle('ninja-selleasy-single', cards.length === 1);
  };

  const prepare = (scope = document) => {
    if (scope.matches?.(CARD)) prepareCard(scope);
    scope.querySelectorAll?.(`${ROOT} ${CARD}`).forEach(prepareCard);

    const roots = new Set();
    if (scope.matches?.(ROOT)) roots.add(scope);
    scope.closest?.(ROOT) && roots.add(scope.closest(ROOT));
    scope.querySelectorAll?.(ROOT).forEach((root) => roots.add(root));
    roots.forEach(prepareRoot);
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest(`${ROOT} ${CARD}`);
    if (!card || event.target.closest(INTERACTIVE)) return;

    const selection = window.getSelection?.();
    if (selection && !selection.isCollapsed) return;

    card.querySelector(CHECKBOX)?.click();
  });

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) prepare(node);
      });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      prepare();
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  } else {
    prepare();
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
